var data = { header:{ text:"#### Online ordering for Personalized Cancer Monitoring is not available in your practice location.",
    closeButton:true },
  body:{ text:"Please select a different practice or submit your order using a paper order form." },
  buttons:[ { text:"OK",
      isPrimary:true } ] };
data.header;
data.body;
data.buttons;

export { data as default };
//# sourceMappingURL=pcm_restricted_practice_location.esm.js.map
